export default __webpack_public_path__ + "static/media/exclusiveFerro.abb1626d.jpg";